export interface PeriodInterval {
  start: Date;
  end: Date;
}

export enum Periodicity {
  MONTH = "month",
  QUARTER = "quarter",
  WEEK = "week",
}

export interface DateInPeriod {
  date: Date;
  formatted: string;
}
